// extracted by mini-css-extract-plugin
export var searchHeader = "_7z-0";
export var searchHeaderDark = "_7z-1";